import React, { Component } from "react";
import html2pdf from "html2pdf.js";
import { notification } from "antd";
import PropTypes from "prop-types";
import dateFormat from "dateformat";
import { formatMoney } from "../../App";
import "./PDF.css";

export default class PDF extends Component {
  Notification = () => {
    notification.info({
      description: "No Prescription or Medicine Data Found to Generate Invoice",
      placement: "topRight",
    });
  };

  generatePdf = () => {
    const { weekMonthYearData, pdfData } = this.props;
    let list = [];

    if (Array.isArray(weekMonthYearData) && weekMonthYearData.length > 0) {
      list = weekMonthYearData;
    } else if (pdfData?.p_medicinedetails) {
      try {
        const parsed =
          typeof pdfData.p_medicinedetails === "string"
            ? JSON.parse(pdfData.p_medicinedetails)
            : pdfData.p_medicinedetails;
        if (Array.isArray(parsed)) list = parsed;
      } catch (e) {
        console.error("Error parsing pdfData.p_medicinedetails:", e);
      }
    }

    if (list.length === 0) {
      this.Notification();
      return;
    }

    const element = document.getElementById("pdfContainer");
    if (element) {
      const invoiceNo =
        pdfData?.custom_order_id ||
        pdfData?.prescription_id ||
        "INV-" + Date.now();
      const patientName =
        pdfData?.customer || pdfData?.name || "Patient";
      const cleanFilename = `Invoice_${invoiceNo}_${patientName.replace(/\s+/g, "_")}.pdf`;

      html2pdf()
        .from(element)
        .set({
          filename: cleanFilename,
          margin: [10, 10, 10, 10],
          jsPDF: {
            unit: "pt",
            format: "a4",
            orientation: "portrait",
          },
          html2canvas: {
            scale: 3,
            useCORS: true,
            dpi: 300,
            letterRendering: true,
            logging: false,
          },
          pagebreak: { mode: "avoid-all" },
        })
        .save();
    } else {
      console.error("PDF container not found.");
    }
  };

  render() {
    const { pdfData, weekMonthYearData } = this.props || {};
    let medicineList = [];

    if (Array.isArray(weekMonthYearData) && weekMonthYearData.length > 0) {
      medicineList = weekMonthYearData;
    } else if (pdfData?.p_medicinedetails) {
      try {
        const parsed =
          typeof pdfData.p_medicinedetails === "string"
            ? JSON.parse(pdfData.p_medicinedetails)
            : pdfData.p_medicinedetails;
        if (Array.isArray(parsed)) medicineList = parsed;
      } catch (e) {}
    }

    const clinicName =
      pdfData?.clinic_name ||
      pdfData?.clinicName ||
      pdfData?.hospital_name ||
      localStorage.getItem("clinic_name") ||
      "";

    const pharmacyName =
      pdfData?.pharmacy_name ||
      pdfData?.pharmacyName ||
      localStorage.getItem("pharmacy_name") ||
      localStorage.getItem("User_name") ||
      "Pharmacy & Medical Dispensary";

    const pharmacyAddress =
      pdfData?.pharmacy_address ||
      pdfData?.clinic_address ||
      pdfData?.vendor_address ||
      localStorage.getItem("pharmacy_address") ||
      "";

    const pharmacyPhone =
      pdfData?.pharmacy_phone ||
      pdfData?.vendor_phone ||
      localStorage.getItem("pharmacy_phone") ||
      "";

    const pharmacyEmail =
      pdfData?.pharmacy_email ||
      pdfData?.vendor_email ||
      localStorage.getItem("pharmacy_email") ||
      "";

    const contactParts = [];
    if (pharmacyAddress) contactParts.push(pharmacyAddress);
    if (pharmacyPhone) contactParts.push(`Tel: ${pharmacyPhone}`);
    if (pharmacyEmail) contactParts.push(pharmacyEmail);
    const contactLine = contactParts.join(" • ");

    const patientName =
      pdfData?.customer || pdfData?.name || "Walk-in Patient";
    const patientPhone =
      pdfData?.customer_phno || pdfData?.phone_no || "-";
    const patientGender = pdfData?.gender || "-";

    let rawAge = pdfData?.age || pdfData?.customer_age;
    if (!rawAge && pdfData?.customer_dob) {
      const dobVal = pdfData.customer_dob;
      // SP aliases age column as customer_dob — check if it's a plain number first
      if (!isNaN(Number(dobVal)) && Number(dobVal) > 0 && Number(dobVal) < 150) {
        rawAge = Number(dobVal);
      } else {
        const birthDate = new Date(dobVal);
        if (!isNaN(birthDate.getTime())) {
          rawAge = new Date().getFullYear() - birthDate.getFullYear();
        }
      }
    }
    const patientAge =
      rawAge && !isNaN(Number(rawAge)) && Number(rawAge) > 0
        ? `${rawAge} yrs`
        : "-";

    let rawDoctorName =
      pdfData?.doctor_name || pdfData?.doctorName || "";
    rawDoctorName = rawDoctorName.replace(/^[.\s]+/, "").trim();
    while (
      rawDoctorName.toLowerCase().startsWith("dr.") ||
      rawDoctorName.toLowerCase().startsWith("dr ")
    ) {
      rawDoctorName = rawDoctorName.replace(/^dr[.\s]+/i, "").trim();
    }
    const doctorName = rawDoctorName ? `Dr. ${rawDoctorName}` : "Clinic Doctor";
    const doctorQual = pdfData?.doctor_qualification || "MBBS";
    const invoiceNo =
      pdfData?.custom_order_id || pdfData?.prescription_id
        ? `#${pdfData.custom_order_id || pdfData.prescription_id}`
        : "#INV-" + (pdfData?.order_id || "001");
    const invoiceDate =
      pdfData?.prescript_date || pdfData?.created_on || new Date();
    const isPaid =
      pdfData?.payment_status === 1 ||
      pdfData?.status_id === 8 ||
      pdfData?.status === "Delivered";

    const currency =
      pdfData?.currency || "₹";

    const totalAmount = medicineList.reduce((sum, item) => {
      const lineTotal =
        parseFloat(item.price) ||
        parseFloat(item.amount) ||
        (parseFloat(item.per_tablet_price) ||
          parseFloat(item.unit_rate) ||
          0) *
          (Number(item.totalmedicine) ||
            Number(item.quantity) ||
            1);
      return sum + lineTotal;
    }, 0);

    return (
      <div
        style={{
          position: "fixed",
          left: "-9999px",
          top: "0",
          width: "794px",
          zIndex: -1000,
        }}
      >
        <div id="pdfContainer" className="invoice-pdf-wrapper">
          {/* Top Header */}
          <div className="invoice-header">
            <div className="hospital-brand">
              <div className="hospital-logo-badge">+</div>
              <div>
                <h1 className="hospital-name">
                  {clinicName || pharmacyName}
                </h1>
                {clinicName && pharmacyName && clinicName !== pharmacyName && (
                  <p className="pharmacy-subname">{pharmacyName}</p>
                )}
                {contactLine && (
                  <p className="hospital-contact">{contactLine}</p>
                )}
              </div>
            </div>
            <div className="invoice-meta-badge">
              <div className="invoice-badge-title">PHARMACY INVOICE</div>
              <div className="invoice-number">{invoiceNo}</div>
              <div className="invoice-date">
                Date: {dateFormat(invoiceDate, "dd-mmm-yyyy hh:MM TT")}
              </div>
              <div
                className={`invoice-payment-status ${
                  isPaid ? "status-paid" : "status-pending"
                }`}
              >
                {isPaid ? "PAID & DISPENSED" : "PAYMENT PENDING"}
              </div>
            </div>
          </div>

          <hr className="divider-line" />

          {/* Patient & Doctor Details Info Box */}
          <div className="info-cards-grid">
            <div className="info-card">
              <div className="card-title">PATIENT DETAILS</div>
              <div className="card-row">
                <span className="label">Name:</span>
                <span className="value font-bold">{patientName}</span>
              </div>
              <div className="card-row">
                <span className="label">Age / Gender:</span>
                <span className="value">
                  {patientAge !== "-" ? `${patientAge} / ` : ""}{patientGender}
                </span>
              </div>
              <div className="card-row">
                <span className="label">Phone Number:</span>
                <span className="value">{patientPhone}</span>
              </div>
            </div>

            <div className="info-card">
              <div className="card-title">PRESCRIPTION & DOCTOR DETAILS</div>
              <div className="card-row">
                <span className="label">Prescribed By:</span>
                <span className="value font-bold text-teal">
                  {doctorName}
                </span>
              </div>
              <div className="card-row">
                <span className="label">Qualification:</span>
                <span className="value">{doctorQual}</span>
              </div>
              <div className="card-row">
                <span className="label">Prescription Date:</span>
                <span className="value">
                  {dateFormat(invoiceDate, "dd-mmm-yyyy")}
                </span>
              </div>
            </div>
          </div>

          {/* Medicines Table */}
          <div className="invoice-table-wrapper">
            <table className="invoice-table">
              <thead>
                <tr>
                  <th style={{ width: "35px", textAlign: "center" }}>#</th>
                  <th style={{ textAlign: "left" }}>
                    Item / Medicine Description
                  </th>
                  <th style={{ width: "130px", textAlign: "center" }}>
                    Schedule
                  </th>
                  <th style={{ width: "60px", textAlign: "center" }}>Days</th>
                  <th style={{ width: "55px", textAlign: "center" }}>Qty</th>
                  <th style={{ width: "95px", textAlign: "right" }}>
                    Unit Rate ({currency})
                  </th>
                  <th style={{ width: "105px", textAlign: "right" }}>
                    Total ({currency})
                  </th>
                </tr>
              </thead>
              <tbody>
                {medicineList.map((item, idx) => {
                  const days = Number(item.days) || 1;
                  const counts =
                    Array.isArray(item.counts) && item.counts.length >= 4
                      ? item.counts
                      : [
                          Number(item.morning) || 0,
                          Number(item.afternoon) || 0,
                          Number(item.evening) || 0,
                          Number(item.night) || 0,
                        ];
                  const dailyCount =
                    counts.reduce((a, b) => a + (Number(b) || 0), 0) || 1;
                  const totalQty =
                    Number(item.totalmedicine) ||
                    Number(item.quantity) ||
                    days * dailyCount;
                  const unitRate =
                    parseFloat(item.per_tablet_price) ||
                    parseFloat(item.unit_rate) ||
                    parseFloat(item.unitRate) ||
                    0;
                  const lineTotal =
                    parseFloat(item.price) ||
                    parseFloat(item.amount) ||
                    unitRate * totalQty;

                  const scheduleText = counts.some((c) => c > 0)
                    ? counts.join("-")
                    : item.frequency || "-";

                  const foodStr =
                    item.foodtype === 0
                      ? "Before Food"
                      : item.foodtype === 1
                      ? "After Food"
                      : "";

                  return (
                    <tr key={idx}>
                      <td
                        style={{
                          textAlign: "center",
                          fontWeight: 600,
                          color: "#64748b",
                        }}
                      >
                        {idx + 1}
                      </td>
                      <td>
                        <div className="med-name">
                          {item.name ||
                            item.medicine_name ||
                            `Medicine #${idx + 1}`}
                        </div>
                        {item.dosage && (
                          <span className="med-dosage">{item.dosage}</span>
                        )}
                        {item.instruction && (
                          <div className="med-instruction">
                            {item.instruction}
                          </div>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <div className="schedule-badge">{scheduleText}</div>
                        {foodStr && <div className="food-badge">{foodStr}</div>}
                      </td>
                      <td style={{ textAlign: "center", fontWeight: 600 }}>
                        {days}
                      </td>
                      <td style={{ textAlign: "center", fontWeight: 700 }}>
                        {totalQty}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          fontFamily: "monospace",
                        }}
                      >
                        {formatMoney(unitRate)}
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          fontWeight: 700,
                          fontFamily: "monospace",
                          color: "#0f766e",
                        }}
                      >
                        {formatMoney(lineTotal)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Invoice Summary & Financial Totals */}
          <div className="invoice-summary-section">
            <div className="terms-box">
              <div className="terms-title">Terms & Notes:</div>
              <ul className="terms-list">
                <li>Medicines once dispensed cannot be returned or refunded.</li>
                <li>
                  Keep medicines out of reach of children. Store in a cool, dry
                  place.
                </li>
                <li>
                  Take prescribed medications strictly according to doctor's
                  instructions.
                </li>
              </ul>
            </div>

            <div className="totals-box">
              <div className="total-row">
                <span>Subtotal:</span>
                <span className="font-mono font-bold">
                  {formatMoney(totalAmount)} {currency}
                </span>
              </div>
              <div className="total-row">
                <span>Tax / VAT (0%):</span>
                <span className="font-mono">0.000 {currency}</span>
              </div>
              <div className="total-row grand-total">
                <span>Grand Total:</span>
                <span className="font-mono grand-amount">
                  {formatMoney(totalAmount)} {currency}
                </span>
              </div>
            </div>
          </div>

          {/* Footer Signature */}
          <div className="invoice-footer">
            <div className="footer-left">
              <p className="thankyou-msg">
                Thank you for choosing {pharmacyName || clinicName || "our Pharmacy"}!
              </p>
              <p className="gen-time">
                System generated electronic invoice {clinicName ? `• ${clinicName}` : ""}
              </p>
            </div>
            <div className="footer-right">
              <div className="sig-line"></div>
              <p className="sig-label">
                Authorized Pharmacist Signature & Stamp
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PDF.propTypes = {
  weekMonthYearData: PropTypes.array,
  pdfData: PropTypes.object,
  headingTitle: PropTypes.string,
  filename: PropTypes.string,
};
